import axios from "axios";
import "../../common/axiosInterceptor/axios-interceptor";

export const SystemVersionDetailsAPI = async () => {
    return axios({
        method: 'get',
        url: `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/getAllVersionNumberTestEnv`,
        authRequired: true
    })
}